import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const SiteContentCtx = createContext(null);

const DEFAULT = {
  hero_headline: "Design the garment that has never existed.",
  hero_subhead: "Choose your silhouette, thread, and embellishment. Our atelier brings it to life — with an AI preview before a single stitch is made.",
  tagline: "A bespoke atelier where every thread is chosen by the wearer.",
  contact_email: "care@parkcollections.co.in",
  contact_phone: "+91 98xxx 00000",
  atelier_address: "By appointment",
  atelier_hours: "Mon — Sat · 11am — 7pm",
  instagram: "",
  whatsapp: "",
};

export function SiteContentProvider({ children }) {
  const [content, setContent] = useState(DEFAULT);
  useEffect(() => {
    api.get("/site-content").then((r) => setContent({ ...DEFAULT, ...r.data })).catch(() => {});
  }, []);
  return <SiteContentCtx.Provider value={content}>{children}</SiteContentCtx.Provider>;
}

export const useSiteContent = () => useContext(SiteContentCtx) || DEFAULT;
